"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exponent = void 0;
const exponent = ({ leftValue, rightValue, }) => {
    if (typeof leftValue !== 'number' || typeof rightValue !== 'number') {
        return {
            error: `Exponent error: inputs must be numbers, received: [${leftValue}, ${rightValue}]`,
        };
    }
    const result = Math.pow(leftValue, rightValue);
    return { error: null, result };
};
exports.exponent = exponent;
//# sourceMappingURL=exponent.js.map